
        import * as module0 from './controllers/figure_controller.js'
        const modules = {
            "./controllers/figure_controller.js": module0,
        };
        export default modules;
      